import styled, { keyframes } from 'styled-components';
import { touchFeedback } from '../../../styles/brand';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  width: 4.5rem;
  height: 4.5rem;
  border: 3px solid #e0e0e0;
  border-top-color: #ff9800;
  border-radius: 50%;
  animation: ${spin} 0.75s linear infinite;
  margin: 4rem auto;
`;

export const PageWrapper = styled.div`
  ${touchFeedback}

  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - var(--header-height));
  padding: 2rem 1rem 4rem;
`;

export const StepperContainer = styled.div`
  width: 100%;
  max-width: 520px;
  margin-bottom: 2rem;
`;

export const StepItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;
`;

export const StepLabel = styled.span<{ $active: boolean; $completed: boolean }>`
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.78rem;
  color: ${props => (props.$active || props.$completed ? '#323232' : '#aaa')};
  margin-bottom: 0.4rem;
  text-align: center;
`;

export const StepCircle = styled.div<{
  $active: boolean;
  $completed: boolean;
}>`
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'RedHatDisplay-Bold';
  font-size: 1rem;
  z-index: 1;
  position: relative;

  background: ${props =>
    props.$completed || props.$active ? '#4CAF50' : '#fff'};
  color: ${props => (props.$completed || props.$active ? '#fff' : '#aaa')};
  border: ${props =>
    props.$completed || props.$active ? '3px solid #4CAF50' : '2px solid #ccc'};

  ${props =>
    props.$active &&
    `
    &::before {
      content: '';
      position: absolute;
      width: 3rem;
      height: 3rem;
      border-radius: 50%;
      border: 2.5px solid #FF9800;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  `}
`;

export const StepConnector = styled.div<{ $completed: boolean }>`
  height: 2px;
  flex: 1;
  margin-top: calc(0.78rem + 1.2rem);
  background: ${props => (props.$completed ? '#4CAF50' : '#ccc')};
`;

export const FormCard = styled.div`
  background: #fff;
  border-radius: 1rem;
  border: 1px solid #e2e2e2;
  padding: 2rem;
  width: 100%;
  max-width: 42rem;
  height: 100%;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
`;

export const StepTitle = styled.h2`
  font-family: 'RedHatDisplay-Bold';
  font-size: 1.4rem;
  color: #323232;
  text-align: center;
  margin-bottom: 0.25rem;
`;

export const StepSubtitle = styled.p`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.88rem;
  color: #ff2e3e;
  text-align: center;
  margin-bottom: 1.5rem;
`;

export const NavigationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 680px;
  margin-top: 1.5rem;

  .secondary-button,
  .primary-button {
    height: 3rem;
    border-radius: 0.55rem;
    font-family: 'RedHatDisplay-Bold';
    font-size: 1rem;
    padding: 0 1.8rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .secondary-button {
    border: 1px solid #e2e2e2;

    &:hover {
      border: 1px solid #4caf50;
      svg {
        transition: transform 0.3s;
        stroke: #4caf50;
      }
    }
  }

  .primary-button {
    box-shadow: 0px 3px 10px rgba(255, 152, 0, 0.3);
  }
`;
